<template>
  <p class="paragraph">
    <slot />
  </p>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'TheParagraph',
  });
</script>
<style lang="scss" scoped>
  .paragraph {
    color: $text-color--2;
    position: relative;
    @include normalText;
    @include tablet {
      @include mediumText;
    }

    :deep() a {
      @include link-styles;
    }
  }
</style>
